var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('add-tenant-field',{attrs:{"rules":"required","label":"Harga Sewa","label-for":"rentPrice_txt"}},[_c('bg-input',{attrs:{"id":"rentPrice_txt","value":_vm.price,"disabled":"","readonly":"","prefix":"Rp"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }